<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="solid" (click)="cancel()">
        <ion-icon slot="start" name="close-circle-outline"></ion-icon>
        {{ 'General.Cancel' | translate }}
      </ion-button>
    </ion-buttons>
    <ion-title class="modal-title">{{ options.title | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form (ngSubmit)="ok()" novalidate [formGroup]="form">
    <ion-list>
      <ion-item>
        <ion-label floating>
          {{ options.inputText | translate }}
          @if (formErrors.has('value')) {
            <span color="danger"><br/>{{formErrors.get('value')}}</span>
          }
        </ion-label>
        <ion-input style="margin-left: 5px;" formControlName="value" type="password"></ion-input>
      </ion-item>
    </ion-list>

    <div padding>
      <ion-button type="submit" expand="block" [disabled]="!form.valid" color="primary">{{ options.buttonText | translate }}
      </ion-button>
    </div>
  </form>
</ion-content>